/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * PwC Web App Accelerator API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import { useCallback } from 'react';

import type {
    AbsenceReasonsResponse,
    ApplicationVersionResponse,
    ContactPersonResponse,
    CreateApplicationContactRequest,
    CreateTenantContactRequest,
    CreateTenantRequest,
    CreateUserRequest,
    EditContactPersonRequest,
    EditPolicyRequest,
    EditSelfDeclarationRequest,
    EditTenantRequest,
    EditUserRequest,
    GetV1BusinessMetricsSuperAdminUserLoginsParams,
    GetV1SelfDeclarationPaginatedHistoryParams,
    GetV1TenantSuperAdminParams,
    GetV1UserAdminParams,
    PaginatedHistoryDto,
    PaginatedTenantResponse,
    PaginatedUserLoginsResponse,
    PaginatedUserResponse,
    PlannedDeclarationRequest,
    PlannedDeclarationResponse,
    PolicyResponse,
    PolicyVersionResponse,
    PutV1TenantSuperAdminRestoreTenantIdParams,
    RoleResponse,
    SelfDeclaration,
    SelfDeclarationHistory,
    TenantResponse,
    UnforeseenDeclarationRequest,
    UnforeseenDeclarationResponse,
    UserInfoResponse,
    UserLoginsSummaryResponse,
    UserPreferencesRequest,
    UserPreferencesResponse,
    UserResponse,
} from './models';

import { useCustomAxios } from '../mutator/custom-instance';
import type { ErrorType } from '../mutator/custom-instance';

/**
 * @summary Get all absence reasons for declaration type.
 */
export const useGetV1AbsenceReasonsHook = () => {
    const getV1AbsenceReasons = useCustomAxios<AbsenceReasonsResponse[]>();

    return useCallback(() => {
        return getV1AbsenceReasons({
            url: `/v1/AbsenceReasons`,
            method: 'GET',
        });
    }, [getV1AbsenceReasons]);
};

export const getGetV1AbsenceReasonsQueryKey = () => {
    return [`/v1/AbsenceReasons`] as const;
};

export const useGetV1AbsenceReasonsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
    TError = ErrorType<null | null | null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1AbsenceReasonsQueryKey();

    const getV1AbsenceReasons = useGetV1AbsenceReasonsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>
    > = () => getV1AbsenceReasons();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1AbsenceReasonsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>
>;
export type GetV1AbsenceReasonsQueryError = ErrorType<null | null | null>;

export function useGetV1AbsenceReasons<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
    TError = ErrorType<null | null | null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1AbsenceReasonsHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1AbsenceReasonsHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1AbsenceReasons<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
    TError = ErrorType<null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1AbsenceReasonsHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1AbsenceReasonsHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1AbsenceReasons<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
    TError = ErrorType<null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all absence reasons for declaration type.
 */

export function useGetV1AbsenceReasons<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>>,
    TError = ErrorType<null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1AbsenceReasonsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1AbsenceReasonsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a new tenant contact person
 */
export const usePostV1ContactPersonAdminTenantHook = () => {
    const postV1ContactPersonAdminTenant =
        useCustomAxios<ContactPersonResponse>();

    return useCallback(
        (createTenantContactRequest: CreateTenantContactRequest) => {
            return postV1ContactPersonAdminTenant({
                url: `/v1/ContactPerson/Admin/Tenant`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTenantContactRequest,
            });
        },
        [postV1ContactPersonAdminTenant]
    );
};

export const usePostV1ContactPersonAdminTenantMutationOptions = <
    TError = ErrorType<null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        TError,
        { data: CreateTenantContactRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >,
    TError,
    { data: CreateTenantContactRequest },
    TContext
> => {
    const mutationKey = ['postV1ContactPersonAdminTenant'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1ContactPersonAdminTenant =
        usePostV1ContactPersonAdminTenantHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        { data: CreateTenantContactRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ContactPersonAdminTenant(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ContactPersonAdminTenantMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >
>;
export type PostV1ContactPersonAdminTenantMutationBody =
    CreateTenantContactRequest;
export type PostV1ContactPersonAdminTenantMutationError = ErrorType<null>;

/**
 * @summary Create a new tenant contact person
 */
export const usePostV1ContactPersonAdminTenant = <
    TError = ErrorType<null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePostV1ContactPersonAdminTenantHook>
                >
            >,
            TError,
            { data: CreateTenantContactRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >,
    TError,
    { data: CreateTenantContactRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ContactPersonAdminTenantMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const usePutV1ContactPersonAdminContactPersonIdHook = () => {
    const putV1ContactPersonAdminContactPersonId = useCustomAxios<null>();

    return useCallback(
        (
            contactPersonId: number,
            editContactPersonRequest: EditContactPersonRequest
        ) => {
            return putV1ContactPersonAdminContactPersonId({
                url: `/v1/ContactPerson/Admin/${contactPersonId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editContactPersonRequest,
            });
        },
        [putV1ContactPersonAdminContactPersonId]
    );
};

export const usePutV1ContactPersonAdminContactPersonIdMutationOptions = <
    TError = ErrorType<null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        TError,
        { contactPersonId: number; data: EditContactPersonRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number; data: EditContactPersonRequest },
    TContext
> => {
    const mutationKey = ['putV1ContactPersonAdminContactPersonId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1ContactPersonAdminContactPersonId =
        usePutV1ContactPersonAdminContactPersonIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        { contactPersonId: number; data: EditContactPersonRequest }
    > = (props) => {
        const { contactPersonId, data } = props ?? {};

        return putV1ContactPersonAdminContactPersonId(contactPersonId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1ContactPersonAdminContactPersonIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >
>;
export type PutV1ContactPersonAdminContactPersonIdMutationBody =
    EditContactPersonRequest;
export type PutV1ContactPersonAdminContactPersonIdMutationError =
    ErrorType<null>;

export const usePutV1ContactPersonAdminContactPersonId = <
    TError = ErrorType<null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePutV1ContactPersonAdminContactPersonIdHook
                    >
                >
            >,
            TError,
            { contactPersonId: number; data: EditContactPersonRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number; data: EditContactPersonRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1ContactPersonAdminContactPersonIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useDeleteV1ContactPersonAdminContactPersonIdHook = () => {
    const deleteV1ContactPersonAdminContactPersonId = useCustomAxios<null>();

    return useCallback(
        (contactPersonId: number) => {
            return deleteV1ContactPersonAdminContactPersonId({
                url: `/v1/ContactPerson/Admin/${contactPersonId}`,
                method: 'DELETE',
            });
        },
        [deleteV1ContactPersonAdminContactPersonId]
    );
};

export const useDeleteV1ContactPersonAdminContactPersonIdMutationOptions = <
    TError = ErrorType<null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        TError,
        { contactPersonId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number },
    TContext
> => {
    const mutationKey = ['deleteV1ContactPersonAdminContactPersonId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteV1ContactPersonAdminContactPersonId =
        useDeleteV1ContactPersonAdminContactPersonIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        { contactPersonId: number }
    > = (props) => {
        const { contactPersonId } = props ?? {};

        return deleteV1ContactPersonAdminContactPersonId(contactPersonId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1ContactPersonAdminContactPersonIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >
    >;

export type DeleteV1ContactPersonAdminContactPersonIdMutationError =
    ErrorType<null>;

export const useDeleteV1ContactPersonAdminContactPersonId = <
    TError = ErrorType<null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                    >
                >
            >,
            TError,
            { contactPersonId: number },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number },
    TContext
> => {
    const mutationOptions =
        useDeleteV1ContactPersonAdminContactPersonIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const usePostV1AuthLogoutHook = () => {
    const postV1AuthLogout = useCustomAxios<null>();

    return useCallback(() => {
        return postV1AuthLogout({ url: `/v1/Auth/Logout`, method: 'POST' });
    }, [postV1AuthLogout]);
};

export const usePostV1AuthLogoutMutationOptions = <
    TError = ErrorType<null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['postV1AuthLogout'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1AuthLogout = usePostV1AuthLogoutHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
        void
    > = () => {
        return postV1AuthLogout();
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1AuthLogoutMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>
>;

export type PostV1AuthLogoutMutationError = ErrorType<null>;

export const usePostV1AuthLogout = <
    TError = ErrorType<null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
            TError,
            void,
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions = usePostV1AuthLogoutMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useGetV1ContactPersonTenantTenantIdHook = () => {
    const getV1ContactPersonTenantTenantId =
        useCustomAxios<ContactPersonResponse[]>();

    return useCallback(
        (tenantId: number) => {
            return getV1ContactPersonTenantTenantId({
                url: `/v1/ContactPerson/Tenant/${tenantId}`,
                method: 'GET',
            });
        },
        [getV1ContactPersonTenantTenantId]
    );
};

export const getGetV1ContactPersonTenantTenantIdQueryKey = (
    tenantId?: number
) => {
    return [`/v1/ContactPerson/Tenant/${tenantId}`] as const;
};

export const useGetV1ContactPersonTenantTenantIdQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<null | null | null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ContactPersonTenantTenantIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ContactPersonTenantTenantIdQueryKey(tenantId);

    const getV1ContactPersonTenantTenantId =
        useGetV1ContactPersonTenantTenantIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
            >
        >
    > = () => getV1ContactPersonTenantTenantId(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ContactPersonTenantTenantIdQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >
>;
export type GetV1ContactPersonTenantTenantIdQueryError = ErrorType<
    null | null | null
>;

export function useGetV1ContactPersonTenantTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<null | null | null>
>(
    tenantId: number,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ContactPersonTenantTenantIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonTenantTenantIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonTenantTenantIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ContactPersonTenantTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<null | null | null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ContactPersonTenantTenantIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonTenantTenantIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonTenantTenantIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ContactPersonTenantTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<null | null | null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ContactPersonTenantTenantIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1ContactPersonTenantTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<null | null | null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ContactPersonTenantTenantIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1ContactPersonTenantTenantIdQueryOptions(
        tenantId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1ContactPersonApplicationHook = () => {
    const getV1ContactPersonApplication =
        useCustomAxios<ContactPersonResponse[]>();

    return useCallback(() => {
        return getV1ContactPersonApplication({
            url: `/v1/ContactPerson/Application`,
            method: 'GET',
        });
    }, [getV1ContactPersonApplication]);
};

export const getGetV1ContactPersonApplicationQueryKey = () => {
    return [`/v1/ContactPerson/Application`] as const;
};

export const useGetV1ContactPersonApplicationQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1ContactPersonApplicationHook>
                >
            >,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1ContactPersonApplicationQueryKey();

    const getV1ContactPersonApplication =
        useGetV1ContactPersonApplicationHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >
    > = () => getV1ContactPersonApplication();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ContactPersonApplicationQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>>
>;
export type GetV1ContactPersonApplicationQueryError = ErrorType<unknown>;

export function useGetV1ContactPersonApplication<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1ContactPersonApplicationHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonApplicationHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonApplicationHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ContactPersonApplication<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1ContactPersonApplicationHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonApplicationHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1ContactPersonApplicationHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ContactPersonApplication<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1ContactPersonApplicationHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1ContactPersonApplication<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1ContactPersonApplicationHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1ContactPersonApplicationQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Returns list of the claims for default authentication schema
 */
export const useGetV1IdentityUserInfoHook = () => {
    const getV1IdentityUserInfo = useCustomAxios<UserInfoResponse>();

    return useCallback(() => {
        return getV1IdentityUserInfo({
            url: `/v1/Identity/UserInfo`,
            method: 'GET',
        });
    }, [getV1IdentityUserInfo]);
};

export const getGetV1IdentityUserInfoQueryKey = () => {
    return [`/v1/Identity/UserInfo`] as const;
};

export const useGetV1IdentityUserInfoQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<null | null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
            >,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1IdentityUserInfoQueryKey();

    const getV1IdentityUserInfo = useGetV1IdentityUserInfoHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>
    > = () => getV1IdentityUserInfo();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1IdentityUserInfoQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>
>;
export type GetV1IdentityUserInfoQueryError = ErrorType<null | null>;

export function useGetV1IdentityUserInfo<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<null | null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1IdentityUserInfoHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1IdentityUserInfoHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1IdentityUserInfo<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1IdentityUserInfoHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1IdentityUserInfoHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1IdentityUserInfo<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns list of the claims for default authentication schema
 */

export function useGetV1IdentityUserInfo<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1IdentityUserInfoQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyPrivacyHook = () => {
    const getV1PolicyPrivacy = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyPrivacy({ url: `/v1/Policy/Privacy`, method: 'GET' });
    }, [getV1PolicyPrivacy]);
};

export const getGetV1PolicyPrivacyQueryKey = () => {
    return [`/v1/Policy/Privacy`] as const;
};

export const useGetV1PolicyPrivacyQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyPrivacyQueryKey();

    const getV1PolicyPrivacy = useGetV1PolicyPrivacyHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>
    > = () => getV1PolicyPrivacy();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1PolicyPrivacyQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>
>;
export type GetV1PolicyPrivacyQueryError = ErrorType<null>;

export function useGetV1PolicyPrivacy<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyPrivacy<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyPrivacy<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1PolicyPrivacy<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1PolicyPrivacyQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyCookiesHook = () => {
    const getV1PolicyCookies = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyCookies({ url: `/v1/Policy/Cookies`, method: 'GET' });
    }, [getV1PolicyCookies]);
};

export const getGetV1PolicyCookiesQueryKey = () => {
    return [`/v1/Policy/Cookies`] as const;
};

export const useGetV1PolicyCookiesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyCookiesQueryKey();

    const getV1PolicyCookies = useGetV1PolicyCookiesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>
    > = () => getV1PolicyCookies();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1PolicyCookiesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>
>;
export type GetV1PolicyCookiesQueryError = ErrorType<null>;

export function useGetV1PolicyCookies<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyCookies<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyCookies<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1PolicyCookies<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1PolicyCookiesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyTermsHook = () => {
    const getV1PolicyTerms = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyTerms({ url: `/v1/Policy/Terms`, method: 'GET' });
    }, [getV1PolicyTerms]);
};

export const getGetV1PolicyTermsQueryKey = () => {
    return [`/v1/Policy/Terms`] as const;
};

export const useGetV1PolicyTermsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyTermsQueryKey();

    const getV1PolicyTerms = useGetV1PolicyTermsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>
    > = () => getV1PolicyTerms();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1PolicyTermsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>
>;
export type GetV1PolicyTermsQueryError = ErrorType<null>;

export function useGetV1PolicyTerms<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyTerms<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyTerms<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1PolicyTerms<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1PolicyTermsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyTermsVersionHook = () => {
    const getV1PolicyTermsVersion = useCustomAxios<PolicyVersionResponse>();

    return useCallback(() => {
        return getV1PolicyTermsVersion({
            url: `/v1/Policy/terms/version`,
            method: 'GET',
        });
    }, [getV1PolicyTermsVersion]);
};

export const getGetV1PolicyTermsVersionQueryKey = () => {
    return [`/v1/Policy/terms/version`] as const;
};

export const useGetV1PolicyTermsVersionQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
            >,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1PolicyTermsVersionQueryKey();

    const getV1PolicyTermsVersion = useGetV1PolicyTermsVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>
    > = () => getV1PolicyTermsVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1PolicyTermsVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>
>;
export type GetV1PolicyTermsVersionQueryError = ErrorType<
    null | null | null | null
>;

export function useGetV1PolicyTermsVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyTermsVersionHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyTermsVersionHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyTermsVersionHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyTermsVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyTermsVersionHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyTermsVersionHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyTermsVersionHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyTermsVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyTermsVersionHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1PolicyTermsVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyTermsVersionHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1PolicyTermsVersionQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1PolicyCookiesVersionHook = () => {
    const getV1PolicyCookiesVersion = useCustomAxios<PolicyVersionResponse>();

    return useCallback(() => {
        return getV1PolicyCookiesVersion({
            url: `/v1/Policy/cookies/version`,
            method: 'GET',
        });
    }, [getV1PolicyCookiesVersion]);
};

export const getGetV1PolicyCookiesVersionQueryKey = () => {
    return [`/v1/Policy/cookies/version`] as const;
};

export const useGetV1PolicyCookiesVersionQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
            >,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1PolicyCookiesVersionQueryKey();

    const getV1PolicyCookiesVersion = useGetV1PolicyCookiesVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>>
    > = () => getV1PolicyCookiesVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1PolicyCookiesVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>>
>;
export type GetV1PolicyCookiesVersionQueryError = ErrorType<
    null | null | null | null
>;

export function useGetV1PolicyCookiesVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyCookiesVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1PolicyCookiesVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1PolicyCookiesVersion<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<null | null | null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1PolicyCookiesVersionHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1PolicyCookiesVersionQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const useGetV1RoleAdminAllHook = () => {
    const getV1RoleAdminAll = useCustomAxios<RoleResponse[]>();

    return useCallback(() => {
        return getV1RoleAdminAll({ url: `/v1/Role/Admin/All`, method: 'GET' });
    }, [getV1RoleAdminAll]);
};

export const getGetV1RoleAdminAllQueryKey = () => {
    return [`/v1/Role/Admin/All`] as const;
};

export const useGetV1RoleAdminAllQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1RoleAdminAllQueryKey();

    const getV1RoleAdminAll = useGetV1RoleAdminAllHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>
    > = () => getV1RoleAdminAll();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1RoleAdminAllQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>
>;
export type GetV1RoleAdminAllQueryError = ErrorType<unknown>;

export function useGetV1RoleAdminAll<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1RoleAdminAll<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1RoleAdminAll<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1RoleAdminAll<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1RoleAdminAllQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a new planned Self Declaration for User
 */
export const usePostV1SelfDeclarationPlannedHook = () => {
    const postV1SelfDeclarationPlanned = useCustomAxios<SelfDeclaration>();

    return useCallback(
        (plannedDeclarationRequest: PlannedDeclarationRequest) => {
            return postV1SelfDeclarationPlanned({
                url: `/v1/SelfDeclaration/Planned`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: plannedDeclarationRequest,
            });
        },
        [postV1SelfDeclarationPlanned]
    );
};

export const usePostV1SelfDeclarationPlannedMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1SelfDeclarationPlannedHook>>
        >,
        TError,
        { data: PlannedDeclarationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1SelfDeclarationPlannedHook>>>,
    TError,
    { data: PlannedDeclarationRequest },
    TContext
> => {
    const mutationKey = ['postV1SelfDeclarationPlanned'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1SelfDeclarationPlanned = usePostV1SelfDeclarationPlannedHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1SelfDeclarationPlannedHook>>
        >,
        { data: PlannedDeclarationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1SelfDeclarationPlanned(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1SelfDeclarationPlannedMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1SelfDeclarationPlannedHook>>>
>;
export type PostV1SelfDeclarationPlannedMutationBody =
    PlannedDeclarationRequest;
export type PostV1SelfDeclarationPlannedMutationError = ErrorType<null | null>;

/**
 * @summary Create a new planned Self Declaration for User
 */
export const usePostV1SelfDeclarationPlanned = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePostV1SelfDeclarationPlannedHook>
                >
            >,
            TError,
            { data: PlannedDeclarationRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1SelfDeclarationPlannedHook>>>,
    TError,
    { data: PlannedDeclarationRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1SelfDeclarationPlannedMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new unforeseen Self Declaration for User
 */
export const usePostV1SelfDeclarationUnforeseenHook = () => {
    const postV1SelfDeclarationUnforeseen = useCustomAxios<SelfDeclaration>();

    return useCallback(
        (unforeseenDeclarationRequest: UnforeseenDeclarationRequest) => {
            return postV1SelfDeclarationUnforeseen({
                url: `/v1/SelfDeclaration/Unforeseen`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: unforeseenDeclarationRequest,
            });
        },
        [postV1SelfDeclarationUnforeseen]
    );
};

export const usePostV1SelfDeclarationUnforeseenMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1SelfDeclarationUnforeseenHook>
            >
        >,
        TError,
        { data: UnforeseenDeclarationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1SelfDeclarationUnforeseenHook>>
    >,
    TError,
    { data: UnforeseenDeclarationRequest },
    TContext
> => {
    const mutationKey = ['postV1SelfDeclarationUnforeseen'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1SelfDeclarationUnforeseen =
        usePostV1SelfDeclarationUnforeseenHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1SelfDeclarationUnforeseenHook>
            >
        >,
        { data: UnforeseenDeclarationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1SelfDeclarationUnforeseen(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1SelfDeclarationUnforeseenMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1SelfDeclarationUnforeseenHook>>
    >
>;
export type PostV1SelfDeclarationUnforeseenMutationBody =
    UnforeseenDeclarationRequest;
export type PostV1SelfDeclarationUnforeseenMutationError = ErrorType<
    null | null
>;

/**
 * @summary Create a new unforeseen Self Declaration for User
 */
export const usePostV1SelfDeclarationUnforeseen = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePostV1SelfDeclarationUnforeseenHook>
                >
            >,
            TError,
            { data: UnforeseenDeclarationRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1SelfDeclarationUnforeseenHook>>
    >,
    TError,
    { data: UnforeseenDeclarationRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1SelfDeclarationUnforeseenMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a Planned Submission by Submission ID
 */
export const useGetV1SelfDeclarationPlannedSubmissionIdHook = () => {
    const getV1SelfDeclarationPlannedSubmissionId =
        useCustomAxios<PlannedDeclarationResponse>();

    return useCallback(
        (submissionId: string) => {
            return getV1SelfDeclarationPlannedSubmissionId({
                url: `/v1/SelfDeclaration/Planned/${submissionId}`,
                method: 'GET',
            });
        },
        [getV1SelfDeclarationPlannedSubmissionId]
    );
};

export const getGetV1SelfDeclarationPlannedSubmissionIdQueryKey = (
    submissionId?: string
) => {
    return [`/v1/SelfDeclaration/Planned/${submissionId}`] as const;
};

export const useGetV1SelfDeclarationPlannedSubmissionIdQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPlannedSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1SelfDeclarationPlannedSubmissionIdQueryKey(submissionId);

    const getV1SelfDeclarationPlannedSubmissionId =
        useGetV1SelfDeclarationPlannedSubmissionIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                >
            >
        >
    > = () => getV1SelfDeclarationPlannedSubmissionId(submissionId);

    return {
        queryKey,
        queryFn,
        enabled: !!submissionId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SelfDeclarationPlannedSubmissionIdQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPlannedSubmissionIdHook>
        >
    >
>;
export type GetV1SelfDeclarationPlannedSubmissionIdQueryError = ErrorType<
    null | null
>;

export function useGetV1SelfDeclarationPlannedSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPlannedSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclarationPlannedSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPlannedSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclarationPlannedSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPlannedSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a Planned Submission by Submission ID
 */

export function useGetV1SelfDeclarationPlannedSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPlannedSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPlannedSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1SelfDeclarationPlannedSubmissionIdQueryOptions(
        submissionId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get an Unforeseen Submission by Submission ID
 */
export const useGetV1SelfDeclarationUnforeseenSubmissionIdHook = () => {
    const getV1SelfDeclarationUnforeseenSubmissionId =
        useCustomAxios<UnforeseenDeclarationResponse>();

    return useCallback(
        (submissionId: string) => {
            return getV1SelfDeclarationUnforeseenSubmissionId({
                url: `/v1/SelfDeclaration/Unforeseen/${submissionId}`,
                method: 'GET',
            });
        },
        [getV1SelfDeclarationUnforeseenSubmissionId]
    );
};

export const getGetV1SelfDeclarationUnforeseenSubmissionIdQueryKey = (
    submissionId?: string
) => {
    return [`/v1/SelfDeclaration/Unforeseen/${submissionId}`] as const;
};

export const useGetV1SelfDeclarationUnforeseenSubmissionIdQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1SelfDeclarationUnforeseenSubmissionIdQueryKey(submissionId);

    const getV1SelfDeclarationUnforeseenSubmissionId =
        useGetV1SelfDeclarationUnforeseenSubmissionIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                >
            >
        >
    > = () => getV1SelfDeclarationUnforeseenSubmissionId(submissionId);

    return {
        queryKey,
        queryFn,
        enabled: !!submissionId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SelfDeclarationUnforeseenSubmissionIdQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook>
        >
    >
>;
export type GetV1SelfDeclarationUnforeseenSubmissionIdQueryError = ErrorType<
    null | null
>;

export function useGetV1SelfDeclarationUnforeseenSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclarationUnforeseenSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclarationUnforeseenSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get an Unforeseen Submission by Submission ID
 */

export function useGetV1SelfDeclarationUnforeseenSubmissionId<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook>
        >
    >,
    TError = ErrorType<null | null>
>(
    submissionId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationUnforeseenSubmissionIdHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        useGetV1SelfDeclarationUnforeseenSubmissionIdQueryOptions(
            submissionId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get all Self Declarations - original history format
 */
export const useGetV1SelfDeclarationHook = () => {
    const getV1SelfDeclaration = useCustomAxios<SelfDeclarationHistory>();

    return useCallback(() => {
        return getV1SelfDeclaration({
            url: `/v1/SelfDeclaration`,
            method: 'GET',
        });
    }, [getV1SelfDeclaration]);
};

export const getGetV1SelfDeclarationQueryKey = () => {
    return [`/v1/SelfDeclaration`] as const;
};

export const useGetV1SelfDeclarationQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
    TError = ErrorType<null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1SelfDeclarationQueryKey();

    const getV1SelfDeclaration = useGetV1SelfDeclarationHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>
    > = () => getV1SelfDeclaration();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SelfDeclarationQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>
>;
export type GetV1SelfDeclarationQueryError = ErrorType<null>;

export function useGetV1SelfDeclaration<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
    TError = ErrorType<null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1SelfDeclarationHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1SelfDeclarationHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclaration<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1SelfDeclarationHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1SelfDeclarationHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclaration<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all Self Declarations - original history format
 */

export function useGetV1SelfDeclaration<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1SelfDeclarationHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1SelfDeclarationQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get paginated history response
Sorting by date is done by start date of first date or date range in time order
 */
export const useGetV1SelfDeclarationPaginatedHistoryHook = () => {
    const getV1SelfDeclarationPaginatedHistory =
        useCustomAxios<PaginatedHistoryDto>();

    return useCallback(
        (params?: GetV1SelfDeclarationPaginatedHistoryParams) => {
            return getV1SelfDeclarationPaginatedHistory({
                url: `/v1/SelfDeclaration/PaginatedHistory`,
                method: 'GET',
                params,
            });
        },
        [getV1SelfDeclarationPaginatedHistory]
    );
};

export const getGetV1SelfDeclarationPaginatedHistoryQueryKey = (
    params?: GetV1SelfDeclarationPaginatedHistoryParams
) => {
    return [
        `/v1/SelfDeclaration/PaginatedHistory`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1SelfDeclarationPaginatedHistoryQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
        >
    >,
    TError = ErrorType<null>
>(
    params?: GetV1SelfDeclarationPaginatedHistoryParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPaginatedHistoryHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1SelfDeclarationPaginatedHistoryQueryKey(params);

    const getV1SelfDeclarationPaginatedHistory =
        useGetV1SelfDeclarationPaginatedHistoryHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
            >
        >
    > = () => getV1SelfDeclarationPaginatedHistory(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SelfDeclarationPaginatedHistoryQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
        >
    >
>;
export type GetV1SelfDeclarationPaginatedHistoryQueryError = ErrorType<null>;

export function useGetV1SelfDeclarationPaginatedHistory<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
        >
    >,
    TError = ErrorType<null>
>(
    params: undefined | GetV1SelfDeclarationPaginatedHistoryParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPaginatedHistoryHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPaginatedHistoryHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPaginatedHistoryHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclarationPaginatedHistory<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
        >
    >,
    TError = ErrorType<null>
>(
    params?: GetV1SelfDeclarationPaginatedHistoryParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPaginatedHistoryHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPaginatedHistoryHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1SelfDeclarationPaginatedHistoryHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1SelfDeclarationPaginatedHistory<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
        >
    >,
    TError = ErrorType<null>
>(
    params?: GetV1SelfDeclarationPaginatedHistoryParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPaginatedHistoryHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get paginated history response
Sorting by date is done by start date of first date or date range in time order
 */

export function useGetV1SelfDeclarationPaginatedHistory<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1SelfDeclarationPaginatedHistoryHook>
        >
    >,
    TError = ErrorType<null>
>(
    params?: GetV1SelfDeclarationPaginatedHistoryParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1SelfDeclarationPaginatedHistoryHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1SelfDeclarationPaginatedHistoryQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Update a submission
 */
export const usePutV1SelfDeclarationSubmissionIdHook = () => {
    const putV1SelfDeclarationSubmissionId = useCustomAxios<null>();

    return useCallback(
        (
            submissionId: string,
            editSelfDeclarationRequest: EditSelfDeclarationRequest
        ) => {
            return putV1SelfDeclarationSubmissionId({
                url: `/v1/SelfDeclaration/${submissionId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editSelfDeclarationRequest,
            });
        },
        [putV1SelfDeclarationSubmissionId]
    );
};

export const usePutV1SelfDeclarationSubmissionIdMutationOptions = <
    TError = ErrorType<null | null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1SelfDeclarationSubmissionIdHook>
            >
        >,
        TError,
        { submissionId: string; data: EditSelfDeclarationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1SelfDeclarationSubmissionIdHook>>
    >,
    TError,
    { submissionId: string; data: EditSelfDeclarationRequest },
    TContext
> => {
    const mutationKey = ['putV1SelfDeclarationSubmissionId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1SelfDeclarationSubmissionId =
        usePutV1SelfDeclarationSubmissionIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1SelfDeclarationSubmissionIdHook>
            >
        >,
        { submissionId: string; data: EditSelfDeclarationRequest }
    > = (props) => {
        const { submissionId, data } = props ?? {};

        return putV1SelfDeclarationSubmissionId(submissionId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1SelfDeclarationSubmissionIdMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1SelfDeclarationSubmissionIdHook>>
    >
>;
export type PutV1SelfDeclarationSubmissionIdMutationBody =
    EditSelfDeclarationRequest;
export type PutV1SelfDeclarationSubmissionIdMutationError = ErrorType<
    null | null | null
>;

/**
 * @summary Update a submission
 */
export const usePutV1SelfDeclarationSubmissionId = <
    TError = ErrorType<null | null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePutV1SelfDeclarationSubmissionIdHook>
                >
            >,
            TError,
            { submissionId: string; data: EditSelfDeclarationRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1SelfDeclarationSubmissionIdHook>>
    >,
    TError,
    { submissionId: string; data: EditSelfDeclarationRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1SelfDeclarationSubmissionIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove a submission
 */
export const useDeleteV1SelfDeclarationSubmissionIdHook = () => {
    const deleteV1SelfDeclarationSubmissionId = useCustomAxios<null>();

    return useCallback(
        (submissionId: string) => {
            return deleteV1SelfDeclarationSubmissionId({
                url: `/v1/SelfDeclaration/${submissionId}`,
                method: 'DELETE',
            });
        },
        [deleteV1SelfDeclarationSubmissionId]
    );
};

export const useDeleteV1SelfDeclarationSubmissionIdMutationOptions = <
    TError = ErrorType<null | null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1SelfDeclarationSubmissionIdHook>
            >
        >,
        TError,
        { submissionId: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1SelfDeclarationSubmissionIdHook>
        >
    >,
    TError,
    { submissionId: string },
    TContext
> => {
    const mutationKey = ['deleteV1SelfDeclarationSubmissionId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteV1SelfDeclarationSubmissionId =
        useDeleteV1SelfDeclarationSubmissionIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1SelfDeclarationSubmissionIdHook>
            >
        >,
        { submissionId: string }
    > = (props) => {
        const { submissionId } = props ?? {};

        return deleteV1SelfDeclarationSubmissionId(submissionId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1SelfDeclarationSubmissionIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1SelfDeclarationSubmissionIdHook>
        >
    >
>;

export type DeleteV1SelfDeclarationSubmissionIdMutationError = ErrorType<
    null | null | null
>;

/**
 * @summary Remove a submission
 */
export const useDeleteV1SelfDeclarationSubmissionId = <
    TError = ErrorType<null | null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useDeleteV1SelfDeclarationSubmissionIdHook
                    >
                >
            >,
            TError,
            { submissionId: string },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1SelfDeclarationSubmissionIdHook>
        >
    >,
    TError,
    { submissionId: string },
    TContext
> => {
    const mutationOptions =
        useDeleteV1SelfDeclarationSubmissionIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the list of total login count and most recent login for a user.
 */
export const useGetV1BusinessMetricsSuperAdminUserLoginsHook = () => {
    const getV1BusinessMetricsSuperAdminUserLogins =
        useCustomAxios<PaginatedUserLoginsResponse>();

    return useCallback(
        (params?: GetV1BusinessMetricsSuperAdminUserLoginsParams) => {
            return getV1BusinessMetricsSuperAdminUserLogins({
                url: `/v1/BusinessMetrics/SuperAdmin/UserLogins`,
                method: 'GET',
                params,
            });
        },
        [getV1BusinessMetricsSuperAdminUserLogins]
    );
};

export const getGetV1BusinessMetricsSuperAdminUserLoginsQueryKey = (
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams
) => {
    return [
        `/v1/BusinessMetrics/SuperAdmin/UserLogins`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1BusinessMetricsSuperAdminUserLoginsQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1BusinessMetricsSuperAdminUserLoginsQueryKey(params);

    const getV1BusinessMetricsSuperAdminUserLogins =
        useGetV1BusinessMetricsSuperAdminUserLoginsHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                >
            >
        >
    > = () => getV1BusinessMetricsSuperAdminUserLogins(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1BusinessMetricsSuperAdminUserLoginsQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >
>;
export type GetV1BusinessMetricsSuperAdminUserLoginsQueryError =
    ErrorType<unknown>;

export function useGetV1BusinessMetricsSuperAdminUserLogins<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params: undefined | GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1BusinessMetricsSuperAdminUserLogins<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1BusinessMetricsSuperAdminUserLogins<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the list of total login count and most recent login for a user.
 */

export function useGetV1BusinessMetricsSuperAdminUserLogins<
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        useGetV1BusinessMetricsSuperAdminUserLoginsQueryOptions(
            params,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Returns the summary of user logins
 */
export const useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook =
    () => {
        const getV1BusinessMetricsSuperAdminUserLoginsSummaryContext =
            useCustomAxios<UserLoginsSummaryResponse>();

        return useCallback(
            (context: string) => {
                return getV1BusinessMetricsSuperAdminUserLoginsSummaryContext({
                    url: `/v1/BusinessMetrics/SuperAdmin/UserLoginsSummary/${context}`,
                    method: 'GET',
                });
            },
            [getV1BusinessMetricsSuperAdminUserLoginsSummaryContext]
        );
    };

export const getGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryKey =
    (context?: string) => {
        return [
            `/v1/BusinessMetrics/SuperAdmin/UserLoginsSummary/${context}`,
        ] as const;
    };

export const useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                >
            >
        >,
        TError = ErrorType<null>
    >(
        context: string,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                            >
                        >
                    >,
                    TError,
                    TData
                >
            >;
        }
    ) => {
        const { query: queryOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryKey(
                context
            );

        const getV1BusinessMetricsSuperAdminUserLoginsSummaryContext =
            useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                    >
                >
            >
        > = () =>
            getV1BusinessMetricsSuperAdminUserLoginsSummaryContext(context);

        return {
            queryKey,
            queryFn,
            enabled: !!context,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                    >
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                >
            >
        >
    >;
export type GetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryError =
    ErrorType<null>;

export function useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContext<
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
            >
        >
    >,
    TError = ErrorType<null>
>(
    context: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContext<
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
            >
        >
    >,
    TError = ErrorType<null>
>(
    context: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                        >
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContext<
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
            >
        >
    >,
    TError = ErrorType<null>
>(
    context: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the summary of user logins
 */

export function useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContext<
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
            >
        >
    >,
    TError = ErrorType<null>
>(
    context: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                        >
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryOptions(
            context,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a new application contact
 */
export const usePostV1ContactPersonSuperAdminApplicationHook = () => {
    const postV1ContactPersonSuperAdminApplication =
        useCustomAxios<ContactPersonResponse>();

    return useCallback(
        (createApplicationContactRequest: CreateApplicationContactRequest) => {
            return postV1ContactPersonSuperAdminApplication({
                url: `/v1/ContactPerson/SuperAdmin/Application`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createApplicationContactRequest,
            });
        },
        [postV1ContactPersonSuperAdminApplication]
    );
};

export const usePostV1ContactPersonSuperAdminApplicationMutationOptions = <
    TError = ErrorType<null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        TError,
        { data: CreateApplicationContactRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1ContactPersonSuperAdminApplicationHook>
        >
    >,
    TError,
    { data: CreateApplicationContactRequest },
    TContext
> => {
    const mutationKey = ['postV1ContactPersonSuperAdminApplication'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1ContactPersonSuperAdminApplication =
        usePostV1ContactPersonSuperAdminApplicationHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        { data: CreateApplicationContactRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ContactPersonSuperAdminApplication(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ContactPersonSuperAdminApplicationMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >
    >;
export type PostV1ContactPersonSuperAdminApplicationMutationBody =
    CreateApplicationContactRequest;
export type PostV1ContactPersonSuperAdminApplicationMutationError =
    ErrorType<null>;

/**
 * @summary Create a new application contact
 */
export const usePostV1ContactPersonSuperAdminApplication = <
    TError = ErrorType<null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1ContactPersonSuperAdminApplicationHook
                    >
                >
            >,
            TError,
            { data: CreateApplicationContactRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1ContactPersonSuperAdminApplicationHook>
        >
    >,
    TError,
    { data: CreateApplicationContactRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ContactPersonSuperAdminApplicationMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const usePutV1PolicySuperAdminPolicyIdHook = () => {
    const putV1PolicySuperAdminPolicyId = useCustomAxios<PolicyResponse>();

    return useCallback(
        (policyId: number, editPolicyRequest: EditPolicyRequest) => {
            return putV1PolicySuperAdminPolicyId({
                url: `/v1/Policy/SuperAdmin/${policyId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editPolicyRequest,
            });
        },
        [putV1PolicySuperAdminPolicyId]
    );
};

export const usePutV1PolicySuperAdminPolicyIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        TError,
        { policyId: number; data: EditPolicyRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
    >,
    TError,
    { policyId: number; data: EditPolicyRequest },
    TContext
> => {
    const mutationKey = ['putV1PolicySuperAdminPolicyId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1PolicySuperAdminPolicyId =
        usePutV1PolicySuperAdminPolicyIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        { policyId: number; data: EditPolicyRequest }
    > = (props) => {
        const { policyId, data } = props ?? {};

        return putV1PolicySuperAdminPolicyId(policyId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1PolicySuperAdminPolicyIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>>
>;
export type PutV1PolicySuperAdminPolicyIdMutationBody = EditPolicyRequest;
export type PutV1PolicySuperAdminPolicyIdMutationError = ErrorType<null | null>;

export const usePutV1PolicySuperAdminPolicyId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>
                >
            >,
            TError,
            { policyId: number; data: EditPolicyRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
    >,
    TError,
    { policyId: number; data: EditPolicyRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1PolicySuperAdminPolicyIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useGetV1TenantSuperAdminTenantIdHook = () => {
    const getV1TenantSuperAdminTenantId = useCustomAxios<TenantResponse>();

    return useCallback(
        (tenantId: number) => {
            return getV1TenantSuperAdminTenantId({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'GET',
            });
        },
        [getV1TenantSuperAdminTenantId]
    );
};

export const getGetV1TenantSuperAdminTenantIdQueryKey = (tenantId?: number) => {
    return [`/v1/Tenant/SuperAdmin/${tenantId}`] as const;
};

export const useGetV1TenantSuperAdminTenantIdQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                    >
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1TenantSuperAdminTenantIdQueryKey(tenantId);

    const getV1TenantSuperAdminTenantId =
        useGetV1TenantSuperAdminTenantIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
        >
    > = () => getV1TenantSuperAdminTenantId(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1TenantSuperAdminTenantIdQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>>
>;
export type GetV1TenantSuperAdminTenantIdQueryError = ErrorType<null>;

export function useGetV1TenantSuperAdminTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<null>
>(
    tenantId: number,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1TenantSuperAdminTenantIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1TenantSuperAdminTenantIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1TenantSuperAdminTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1TenantSuperAdminTenantIdHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetV1TenantSuperAdminTenantIdHook
                            >
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1TenantSuperAdminTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1TenantSuperAdminTenantId<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<null>
>(
    tenantId: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1TenantSuperAdminTenantIdQueryOptions(
        tenantId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const usePutV1TenantSuperAdminTenantIdHook = () => {
    const putV1TenantSuperAdminTenantId = useCustomAxios<TenantResponse>();

    return useCallback(
        (tenantId: number, editTenantRequest: EditTenantRequest) => {
            return putV1TenantSuperAdminTenantId({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editTenantRequest,
            });
        },
        [putV1TenantSuperAdminTenantId]
    );
};

export const usePutV1TenantSuperAdminTenantIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
        >,
        TError,
        { tenantId: number; data: EditTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number; data: EditTenantRequest },
    TContext
> => {
    const mutationKey = ['putV1TenantSuperAdminTenantId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1TenantSuperAdminTenantId =
        usePutV1TenantSuperAdminTenantIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
        >,
        { tenantId: number; data: EditTenantRequest }
    > = (props) => {
        const { tenantId, data } = props ?? {};

        return putV1TenantSuperAdminTenantId(tenantId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1TenantSuperAdminTenantIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>>
>;
export type PutV1TenantSuperAdminTenantIdMutationBody = EditTenantRequest;
export type PutV1TenantSuperAdminTenantIdMutationError = ErrorType<null | null>;

export const usePutV1TenantSuperAdminTenantId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>
                >
            >,
            TError,
            { tenantId: number; data: EditTenantRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number; data: EditTenantRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1TenantSuperAdminTenantIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useDeleteV1TenantSuperAdminTenantIdHook = () => {
    const deleteV1TenantSuperAdminTenantId = useCustomAxios<null>();

    return useCallback(
        (tenantId: number) => {
            return deleteV1TenantSuperAdminTenantId({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'DELETE',
            });
        },
        [deleteV1TenantSuperAdminTenantId]
    );
};

export const useDeleteV1TenantSuperAdminTenantIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>
            >
        >,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationKey = ['deleteV1TenantSuperAdminTenantId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteV1TenantSuperAdminTenantId =
        useDeleteV1TenantSuperAdminTenantIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>
            >
        >,
        { tenantId: number }
    > = (props) => {
        const { tenantId } = props ?? {};

        return deleteV1TenantSuperAdminTenantId(tenantId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1TenantSuperAdminTenantIdMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>>
    >
>;

export type DeleteV1TenantSuperAdminTenantIdMutationError = ErrorType<
    null | null
>;

export const useDeleteV1TenantSuperAdminTenantId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>
                >
            >,
            TError,
            { tenantId: number },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationOptions =
        useDeleteV1TenantSuperAdminTenantIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useGetV1TenantSuperAdminHook = () => {
    const getV1TenantSuperAdmin = useCustomAxios<PaginatedTenantResponse>();

    return useCallback(
        (params?: GetV1TenantSuperAdminParams) => {
            return getV1TenantSuperAdmin({
                url: `/v1/Tenant/SuperAdmin`,
                method: 'GET',
                params,
            });
        },
        [getV1TenantSuperAdmin]
    );
};

export const getGetV1TenantSuperAdminQueryKey = (
    params?: GetV1TenantSuperAdminParams
) => {
    return [`/v1/Tenant/SuperAdmin`, ...(params ? [params] : [])] as const;
};

export const useGetV1TenantSuperAdminQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<null | null>
>(
    params?: GetV1TenantSuperAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
                >,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1TenantSuperAdminQueryKey(params);

    const getV1TenantSuperAdmin = useGetV1TenantSuperAdminHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>>
    > = () => getV1TenantSuperAdmin(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1TenantSuperAdminQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>>
>;
export type GetV1TenantSuperAdminQueryError = ErrorType<null | null>;

export function useGetV1TenantSuperAdmin<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<null | null>
>(
    params: undefined | GetV1TenantSuperAdminParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1TenantSuperAdminHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1TenantSuperAdminHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1TenantSuperAdmin<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<null | null>
>(
    params?: GetV1TenantSuperAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1TenantSuperAdminHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1TenantSuperAdminHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1TenantSuperAdmin<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<null | null>
>(
    params?: GetV1TenantSuperAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1TenantSuperAdmin<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<null | null>
>(
    params?: GetV1TenantSuperAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1TenantSuperAdminQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const usePostV1TenantSuperAdminHook = () => {
    const postV1TenantSuperAdmin = useCustomAxios<TenantResponse>();

    return useCallback(
        (createTenantRequest: CreateTenantRequest) => {
            return postV1TenantSuperAdmin({
                url: `/v1/Tenant/SuperAdmin`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTenantRequest,
            });
        },
        [postV1TenantSuperAdmin]
    );
};

export const usePostV1TenantSuperAdminMutationOptions = <
    TError = ErrorType<null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
        TError,
        { data: CreateTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
    TError,
    { data: CreateTenantRequest },
    TContext
> => {
    const mutationKey = ['postV1TenantSuperAdmin'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1TenantSuperAdmin = usePostV1TenantSuperAdminHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
        { data: CreateTenantRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TenantSuperAdmin(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TenantSuperAdminMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>
>;
export type PostV1TenantSuperAdminMutationBody = CreateTenantRequest;
export type PostV1TenantSuperAdminMutationError = ErrorType<null>;

export const usePostV1TenantSuperAdmin = <
    TError = ErrorType<null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>
            >,
            TError,
            { data: CreateTenantRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
    TError,
    { data: CreateTenantRequest },
    TContext
> => {
    const mutationOptions = usePostV1TenantSuperAdminMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const usePutV1TenantSuperAdminRestoreTenantIdHook = () => {
    const putV1TenantSuperAdminRestoreTenantId = useCustomAxios<null>();

    return useCallback(
        (
            tenantId: number,
            params?: PutV1TenantSuperAdminRestoreTenantIdParams
        ) => {
            return putV1TenantSuperAdminRestoreTenantId({
                url: `/v1/Tenant/SuperAdmin/restore/${tenantId}`,
                method: 'PUT',
                params,
            });
        },
        [putV1TenantSuperAdminRestoreTenantId]
    );
};

export const usePutV1TenantSuperAdminRestoreTenantIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
            >
        >,
        TError,
        {
            tenantId: number;
            params?: PutV1TenantSuperAdminRestoreTenantIdParams;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
        >
    >,
    TError,
    { tenantId: number; params?: PutV1TenantSuperAdminRestoreTenantIdParams },
    TContext
> => {
    const mutationKey = ['putV1TenantSuperAdminRestoreTenantId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1TenantSuperAdminRestoreTenantId =
        usePutV1TenantSuperAdminRestoreTenantIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
            >
        >,
        {
            tenantId: number;
            params?: PutV1TenantSuperAdminRestoreTenantIdParams;
        }
    > = (props) => {
        const { tenantId, params } = props ?? {};

        return putV1TenantSuperAdminRestoreTenantId(tenantId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1TenantSuperAdminRestoreTenantIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
        >
    >
>;

export type PutV1TenantSuperAdminRestoreTenantIdMutationError = ErrorType<
    null | null
>;

export const usePutV1TenantSuperAdminRestoreTenantId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePutV1TenantSuperAdminRestoreTenantIdHook
                    >
                >
            >,
            TError,
            {
                tenantId: number;
                params?: PutV1TenantSuperAdminRestoreTenantIdParams;
            },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
        >
    >,
    TError,
    { tenantId: number; params?: PutV1TenantSuperAdminRestoreTenantIdParams },
    TContext
> => {
    const mutationOptions =
        usePutV1TenantSuperAdminRestoreTenantIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useGetV1TenantHook = () => {
    const getV1Tenant = useCustomAxios<TenantResponse>();

    return useCallback(() => {
        return getV1Tenant({ url: `/v1/Tenant`, method: 'GET' });
    }, [getV1Tenant]);
};

export const getGetV1TenantQueryKey = () => {
    return [`/v1/Tenant`] as const;
};

export const useGetV1TenantQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1TenantQueryKey();

    const getV1Tenant = useGetV1TenantHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>
    > = () => getV1Tenant();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1TenantQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>
>;
export type GetV1TenantQueryError = ErrorType<null>;

export function useGetV1Tenant<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1Tenant<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1Tenant<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1Tenant<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1TenantQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Returns a list of all users for the requesting user's tenant
Super Admins are able to specify a tenantId from which the users are retrieved
 */
export const useGetV1UserAdminHook = () => {
    const getV1UserAdmin = useCustomAxios<PaginatedUserResponse>();

    return useCallback(
        (params?: GetV1UserAdminParams) => {
            return getV1UserAdmin({
                url: `/v1/User/Admin`,
                method: 'GET',
                params,
            });
        },
        [getV1UserAdmin]
    );
};

export const getGetV1UserAdminQueryKey = (params?: GetV1UserAdminParams) => {
    return [`/v1/User/Admin`, ...(params ? [params] : [])] as const;
};

export const useGetV1UserAdminQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<null>
>(
    params?: GetV1UserAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
                TError,
                TData
            >
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1UserAdminQueryKey(params);

    const getV1UserAdmin = useGetV1UserAdminHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>
    > = () => getV1UserAdmin(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserAdminQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>
>;
export type GetV1UserAdminQueryError = ErrorType<null>;

export function useGetV1UserAdmin<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<null>
>(
    params: undefined | GetV1UserAdminParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1UserAdminHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1UserAdminHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserAdmin<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<null>
>(
    params?: GetV1UserAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1UserAdminHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetV1UserAdminHook>>
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserAdmin<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<null>
>(
    params?: GetV1UserAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns a list of all users for the requesting user's tenant
Super Admins are able to specify a tenantId from which the users are retrieved
 */

export function useGetV1UserAdmin<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<null>
>(
    params?: GetV1UserAdminParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1UserAdminQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a new user
 */
export const usePostV1UserAdminHook = () => {
    const postV1UserAdmin = useCustomAxios<UserResponse>();

    return useCallback(
        (createUserRequest: CreateUserRequest) => {
            return postV1UserAdmin({
                url: `/v1/User/Admin`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createUserRequest,
            });
        },
        [postV1UserAdmin]
    );
};

export const usePostV1UserAdminMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
        TError,
        { data: CreateUserRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
    TError,
    { data: CreateUserRequest },
    TContext
> => {
    const mutationKey = ['postV1UserAdmin'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const postV1UserAdmin = usePostV1UserAdminHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
        { data: CreateUserRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1UserAdmin(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1UserAdminMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>
>;
export type PostV1UserAdminMutationBody = CreateUserRequest;
export type PostV1UserAdminMutationError = ErrorType<null | null>;

/**
 * @summary Create a new user
 */
export const usePostV1UserAdmin = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
            TError,
            { data: CreateUserRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
    TError,
    { data: CreateUserRequest },
    TContext
> => {
    const mutationOptions = usePostV1UserAdminMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Edit an existing user
 */
export const usePutV1UserAdminUserIdHook = () => {
    const putV1UserAdminUserId = useCustomAxios<UserResponse>();

    return useCallback(
        (userId: number, editUserRequest: EditUserRequest) => {
            return putV1UserAdminUserId({
                url: `/v1/User/Admin/${userId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editUserRequest,
            });
        },
        [putV1UserAdminUserId]
    );
};

export const usePutV1UserAdminUserIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
        TError,
        { userId: number; data: EditUserRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
    TError,
    { userId: number; data: EditUserRequest },
    TContext
> => {
    const mutationKey = ['putV1UserAdminUserId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1UserAdminUserId = usePutV1UserAdminUserIdHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
        { userId: number; data: EditUserRequest }
    > = (props) => {
        const { userId, data } = props ?? {};

        return putV1UserAdminUserId(userId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1UserAdminUserIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>
>;
export type PutV1UserAdminUserIdMutationBody = EditUserRequest;
export type PutV1UserAdminUserIdMutationError = ErrorType<null | null>;

/**
 * @summary Edit an existing user
 */
export const usePutV1UserAdminUserId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
            TError,
            { userId: number; data: EditUserRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
    TError,
    { userId: number; data: EditUserRequest },
    TContext
> => {
    const mutationOptions = usePutV1UserAdminUserIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Soft delete an existing user
 */
export const useDeleteV1UserAdminUserIdHook = () => {
    const deleteV1UserAdminUserId = useCustomAxios<null>();

    return useCallback(
        (userId: number) => {
            return deleteV1UserAdminUserId({
                url: `/v1/User/Admin/${userId}`,
                method: 'DELETE',
            });
        },
        [deleteV1UserAdminUserId]
    );
};

export const useDeleteV1UserAdminUserIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationKey = ['deleteV1UserAdminUserId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteV1UserAdminUserId = useDeleteV1UserAdminUserIdHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
        { userId: number }
    > = (props) => {
        const { userId } = props ?? {};

        return deleteV1UserAdminUserId(userId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1UserAdminUserIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>
>;

export type DeleteV1UserAdminUserIdMutationError = ErrorType<null | null>;

/**
 * @summary Soft delete an existing user
 */
export const useDeleteV1UserAdminUserId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>
            >,
            TError,
            { userId: number },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationOptions = useDeleteV1UserAdminUserIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Restore deleted user
 */
export const usePutV1UserAdminRestoreUserIdHook = () => {
    const putV1UserAdminRestoreUserId = useCustomAxios<null>();

    return useCallback(
        (userId: number) => {
            return putV1UserAdminRestoreUserId({
                url: `/v1/User/Admin/restore/${userId}`,
                method: 'PUT',
            });
        },
        [putV1UserAdminRestoreUserId]
    );
};

export const usePutV1UserAdminRestoreUserIdMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>
        >,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationKey = ['putV1UserAdminRestoreUserId'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1UserAdminRestoreUserId = usePutV1UserAdminRestoreUserIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>
        >,
        { userId: number }
    > = (props) => {
        const { userId } = props ?? {};

        return putV1UserAdminRestoreUserId(userId);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1UserAdminRestoreUserIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>>
>;

export type PutV1UserAdminRestoreUserIdMutationError = ErrorType<null | null>;

/**
 * @summary Restore deleted user
 */
export const usePutV1UserAdminRestoreUserId = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>
                >
            >,
            TError,
            { userId: number },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationOptions =
        usePutV1UserAdminRestoreUserIdMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useGetV1UserPreferencesHook = () => {
    const getV1UserPreferences = useCustomAxios<UserPreferencesResponse>();

    return useCallback(() => {
        return getV1UserPreferences({
            url: `/v1/User/Preferences`,
            method: 'GET',
        });
    }, [getV1UserPreferences]);
};

export const getGetV1UserPreferencesQueryKey = () => {
    return [`/v1/User/Preferences`] as const;
};

export const useGetV1UserPreferencesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<null | null>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1UserPreferencesQueryKey();

    const getV1UserPreferences = useGetV1UserPreferencesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>
    > = () => getV1UserPreferences();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserPreferencesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>
>;
export type GetV1UserPreferencesQueryError = ErrorType<null | null>;

export function useGetV1UserPreferences<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<null | null>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1UserPreferencesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1UserPreferencesHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserPreferences<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1UserPreferencesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetV1UserPreferencesHook>
                        >
                    >
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserPreferences<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1UserPreferences<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<null | null>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1UserPreferencesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const usePutV1UserPreferencesHook = () => {
    const putV1UserPreferences = useCustomAxios<UserPreferencesResponse>();

    return useCallback(
        (userPreferencesRequest: UserPreferencesRequest) => {
            return putV1UserPreferences({
                url: `/v1/User/Preferences`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: userPreferencesRequest,
            });
        },
        [putV1UserPreferences]
    );
};

export const usePutV1UserPreferencesMutationOptions = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
        TError,
        { data: UserPreferencesRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
    TError,
    { data: UserPreferencesRequest },
    TContext
> => {
    const mutationKey = ['putV1UserPreferences'];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const putV1UserPreferences = usePutV1UserPreferencesHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
        { data: UserPreferencesRequest }
    > = (props) => {
        const { data } = props ?? {};

        return putV1UserPreferences(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1UserPreferencesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>
>;
export type PutV1UserPreferencesMutationBody = UserPreferencesRequest;
export type PutV1UserPreferencesMutationError = ErrorType<null | null>;

export const usePutV1UserPreferences = <
    TError = ErrorType<null | null>,
    TContext = unknown
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
            TError,
            { data: UserPreferencesRequest },
            TContext
        >;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
    TError,
    { data: UserPreferencesRequest },
    TContext
> => {
    const mutationOptions = usePutV1UserPreferencesMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const useGetV1VersionHook = () => {
    const getV1Version = useCustomAxios<ApplicationVersionResponse>();

    return useCallback(() => {
        return getV1Version({ url: `/v1/Version`, method: 'GET' });
    }, [getV1Version]);
};

export const getGetV1VersionQueryKey = () => {
    return [`/v1/Version`] as const;
};

export const useGetV1VersionQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1VersionQueryKey();

    const getV1Version = useGetV1VersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>
    > = () => getV1Version();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1VersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>
>;
export type GetV1VersionQueryError = ErrorType<unknown>;

export function useGetV1Version<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1Version<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>
                >,
                'initialData'
            >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1Version<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1Version<
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetV1VersionQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}
